import PropTypes from 'prop-types'; // @mui
import Box from '@mui/material/Box';
import {useTheme} from '@mui/material/styles';
// hooks
import {useResponsive} from 'packages/common/hooks/useResponsive';
// components
import {useSettingsContext} from 'packages/common/components/settings';
//
import {NAV, CONTENT_PADDING, SAFE_AREA_X} from '../config-layout';
import {ADMIN_MOBILE_HEADER_HEIGHT} from './mobile-header';
import {BOTTOM_NAV_HEIGHT} from './bottom-nav';

// ----------------------------------------------------------------------

const SPACING = 2;

export default function Main({children, sx, ...other}) {
  const theme = useTheme();
  const settings = useSettingsContext();

  const lgUp = useResponsive('up', 'lg');

  // Le retrait materiel s'ajoute au padding existant plutot que de le remplacer
  const basePadding = theme.spacing(SPACING);

  const isNavHorizontal = settings.themeLayout === 'horizontal';

  const isNavMini = settings.themeLayout === 'mini';

  if (isNavHorizontal) {
    return (
      <Box
        component="main"
        sx={{
          minHeight: 1,
          display: 'flex',
          flexDirection: 'column',
          bgcolor: 'grey.100',
          pt: {
            xs: `calc(${ADMIN_MOBILE_HEADER_HEIGHT}px + env(safe-area-inset-top, 0px) + 12px)`,
            lg: 3,
          },
          pb: {
            xs: `calc(${BOTTOM_NAV_HEIGHT}px + env(safe-area-inset-bottom, 0px) + 12px)`,
            lg: 10,
          },
          pl: SAFE_AREA_X.LEFT,
          pr: SAFE_AREA_X.RIGHT,
          ...(lgUp && {
            pt: 5,
            pb: 15,
          }),
        }}
      >
        {children}
      </Box>
    );
  }

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        minHeight: 1,
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'grey.100',
        p: SPACING,
        pt: {
          xs: `calc(${ADMIN_MOBILE_HEADER_HEIGHT}px + env(safe-area-inset-top, 0px) + 12px)`,
          lg: SPACING,
        },
        pb: {
          xs: `calc(${BOTTOM_NAV_HEIGHT}px + env(safe-area-inset-bottom, 0px) + 12px)`,
          lg: SPACING,
        },
        pl: `calc(${basePadding} + ${SAFE_AREA_X.LEFT})`,
        pr: `calc(${basePadding} + ${SAFE_AREA_X.RIGHT})`,
        ...(lgUp && {
          px: CONTENT_PADDING,
          py: SPACING,
          width: `calc(100% - ${NAV.W_VERTICAL}px)`,
          ...(isNavMini && {
            width: `calc(100% - ${NAV.W_MINI}px)`,
          }),
        }),
        ...sx,
      }}
      {...other}
    >
      {children}
    </Box>
  );
}

Main.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
};
